var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23a5.685 5.685 0 00-4.4-4.033c-3.667-.697-4.033-1.834-4.033-2.567v-1.173c1.32-1.21 2.566-3.19 2.566-5.427V6.28C17.133 2.467 14.42 1 12 1S6.867 2.467 6.867 6.28V9.8c0 2.273 1.246 4.217 2.566 5.427V16.4c0 .733-.733 1.907-4.4 2.567A4.907 4.907 0 001 23",
    stroke: "#5F5F5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconAvatar;